import { render, staticRenderFns } from "./AppTableUser.vue?vue&type=template&id=70bc8dbf&scoped=true&"
import script from "./AppTableUser.vue?vue&type=script&lang=js&"
export * from "./AppTableUser.vue?vue&type=script&lang=js&"
import style0 from "./AppTableUser.vue?vue&type=style&index=0&id=70bc8dbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bc8dbf",
  null
  
)

export default component.exports